import React, { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import DonorPersonalInfo from '../offline-donations/sub-components/donor-personal-info';
import DonorAddressInfo from '../offline-donations/sub-components/donor-address-info';
import TableWidget from '../../../shared/table-widget/table-widget';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import DonationTable from '../../../shared/donation-info/donation-table';
import { DONATION_COLUMNS } from '../../../constants/table-columns.constant';
import axios from 'axios';
import { FIND_DONOR_BY_ID, GET_ALL_DONATIONS, GET_DONATION_STATS, UPDATE_DONOR } from '../../../constants/endpoints';
import PledgeTable from '../../../shared/pledge-table/pledge-table';
import { getSetOrgInfo } from '../../../utils/user-info';
import DynamicFieldsWrapper from '../custom-fields/shared/dynamic-fields/dynamic-fields-wrapper';
import { useCustomFields } from '../custom-fields/hooks/custom-fields.hook';
import AddCustomFieldCanvas from '../custom-fields/add-custom-field-canvas';
import CustomFieldCanvas from '../custom-fields/custom-field-canvas';
import AssignCampaign from '../fundraising/dialogs/assign-campaign';

function DonorDetail(props) {
    const params = useParams();
    //custom fields params
    const attachFieldDialogRef = useRef(null);
    const customFieldCanvasRef = useRef(null);
    const {customFields, getDonorCustomField} = useCustomFields();
    const navigate = useNavigate();
    const assignCampaignDialogRef = useRef(null);
    const [updateDonorLoader, setUpdateDonor] = useState(false);
    const columns = ["Currency", "Total Donations"];
    const [totalDonation, setTotalDonations] = useState([])
    const methods = useForm();
    const orgInfo = getSetOrgInfo();
    const [donorDetail, setDonorDetail] = useState({});
    const { reset, getValues, control, setValue, formState: { isValid, errors } } = methods;

    const [donationsList, setDonationsList] = useState([])


    const findDonorByID = () => {
        axios.get(FIND_DONOR_BY_ID + params?.id)
        .then((res) => {
            if(res?.data?.status){
                reset({
                    donor_info: res?.data?.response
                });
                setDonorDetail(res?.data?.response);
            }
        }).catch((error) => {

        })
    }

    useEffect(() => {
        findDonorByID()
    }, []);

    const updateDonor = (formValues) =>{
        const json = structuredClone(formValues);
        json.field_answers = json.field_answers.flatMap(it => it.answers);
        setUpdateDonor(true);
        json.current_email = donorDetail?.email;
        axios.post((UPDATE_DONOR + params?.id), json)
        .then((res) => {
            setUpdateDonor(false);
            if(res?.data?.status){
                window.location.reload();
            }else{
                alert(res?.data?.message);
            }
            
        }).catch((error) => {
            alert("Failed to update donor detail.");
            setUpdateDonor(false);
        })
    }

    const getDonationsByDonor = (pageNumber) => {
        axios.post(GET_ALL_DONATIONS, {donor_id: params?.id, page_index: pageNumber ? pageNumber : 0, payment_status: 'all'})
        .then((res) => {
            if(res?.data?.status){
                setDonationsList(res?.data?.response)
            }
        }).catch((error) => {

        });
    }

    useEffect(() => {
        getDonationsByDonor();
        getTotalDonations();
    }, []);

    const [pageIndex, setPageIndex] = useState(0);
    const changePage = (pageNumber) => {
        setPageIndex(pageNumber);
        getDonationsByDonor(pageNumber)
    }

    const getTotalDonations = () => {
        axios.post(GET_DONATION_STATS, {donor_id: params?.id, payment_status: 'all'})
        .then((res) => {
            if(res?.data?.status){
                setTotalDonations([{ currency: orgInfo?.currency?.toUpperCase(), total_amount: res?.data?.response?.gross_donations}])
            }
        }).catch((error) => {

        });
    }

    useEffect(() => {
        if (params?.id) {
            getDonorCustomField(params?.id);
        }

    }, [params?.id])

    const refreshCustomFields = () => {
        getDonorCustomField(params?.id);
    }

    return (
        <div className='row'>
            <div>
                <h5 className='font-weight-semibold text-black'>Donor: {params?.name}</h5>
            </div>

            
                <FormProvider {...methods}>
                    <form  onSubmit={methods.handleSubmit(updateDonor)} >
                        <div className='row'>
                    <div className='col-xxl-8 col-xl-6 col-12'>
                    
                        <div className='card' style={{
                            minHeight:'500px',
                            overflow:'auto'
                        }}>
                            <div className='card-body'>
                                <div className='col-12 border-bottom mb-3'>
                                    <div className='d-flex justify-content-between'>
                                        <h6 className='text-bold'>Donor Info</h6>
                                        
                                    </div>
                                </div>

                                {/* injecting donor personal info */}
                                <DonorPersonalInfo />

                                {/* injecting donor address info */}
                                <DonorAddressInfo />
                                 
                            </div>
                            <div className='text-right pe-3'>
                            <button
                            disabled={updateDonorLoader}
                             type='submit' 
                            className={`btn btn-primary position-relative ${updateDonorLoader ? 'button--loading' : ''}`}>Update</button>
                            </div>
                        </div>
                        
                    </div>
                    
                  
                
                <div className='col-xxl-4 col-xl-6 col-12'>
                    <div className='card'>
                        <div className='card-body p-2'>
                            <TableWidget 
                            columns={columns} 
                            data={totalDonation} />
                        </div>
                    </div>
                    
                    <div className='card mt-3' style={{
                            minHeight:'390px',
                            overflow:'auto'
                        }}>
                        <div className='card-body'>
                           
                       <DynamicFieldsWrapper
                            entityInfo={{
                                entity_id: params.id,
                                entity_type: 'donor'
                            }}
                            customFieldCanvasRef={customFieldCanvasRef}
                            isTitle={true}
                            fieldList={customFields}
                            attachFieldDialog={attachFieldDialogRef}
                            control={control} />
                        </div>
                    </div>
                </div>
                </div>
                </form>

</FormProvider>
                
            
            <div className='row'>
                <div className='col-xxl-12 mt-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <Tab.Container defaultActiveKey="donations">
                                <div className="d-flex justify-content-between align-items-center">
                                    <Nav variant="tabs">
                                        <Nav.Item>
                                            <Nav.Link eventKey="donations">Donations</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="pledges">Pledges</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <button onClick={() => {
                                        assignCampaignDialogRef?.current?.setShow(true);
                                        assignCampaignDialogRef?.current?.setDonorEmail(donorDetail?.email);
                                    }} className="btn btn-primary">
                                        + Add Offline Donation
                                    </button>
                                </div>
                                < hr className='m-0' />
                                <Tab.Content>
                                    <Tab.Pane eventKey="donations">
                                        <DonationTable
                                            changePage={changePage}
                                            pageIndex={pageIndex}
                                            data={donationsList}
                                            columns={DONATION_COLUMNS}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="pledges">
                                        <PledgeTable
                                            pledgeStatusModel={[]}
                                            campaignSearchModel={""}
                                            searchModel={""}
                                            donor_id={params?.id}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </div>

            {/*  custom field canvas */}
            <CustomFieldCanvas
                onCloseRefresh={refreshCustomFields}
                ref={customFieldCanvasRef} entityInfo={{
                    entity_id: params.id,
                    entity_type: 'donor'
                }} />
            {/* assign campaign dialog */}
        <AssignCampaign 
        isOfflineDonation={true}
        ref={assignCampaignDialogRef}  />
        </div>
    );
}

export default DonorDetail;